import { useMaterialListWithCache } from "../HubMaterialHookSelect/useMaterialListWithCache";

export const MaterialCell = ({ item }) => {
  const { materials: cached } = useMaterialListWithCache();
  const materials = Array.isArray(cached) ? cached : cached?.materials || [];

  let label = "";
  if (item?.material?.name) label = item?.material?.name;

  if (item?.material) {
    const material = materials?.find((m) => m.id === item?.material);
    label = material?.label || "";
  }

  return <span>{label}</span>;
};

export default MaterialCell;
